import { useQuizById } from "@/hooks/quiz-by-id.hook";
import { mergeWithConfig } from "@/lib/dimensions";
import { cn } from "@/lib/utils";
import { FC, HTMLAttributes } from "react";
import DimensionSummaryCard from "./dimension-summary-card";
import DimensionsBentoSkeleton from "./dimensions-bento-skeleton";

type DimensionsBentoGridProps = HTMLAttributes<HTMLDivElement> & {
  companyId: string;
  applicationQuizId: string;
  showExtraInfo: boolean;
  showScoreProportionInHeader?: boolean;
  gridStyle?: "grid" | "compact";
};

const DimensionsBentoGrid: FC<DimensionsBentoGridProps> = (props) => {
  const gridStyle = props.gridStyle || "grid";

  const { data: quiz, isLoading: quizIsLoading } = useQuizById({
    companyId: props.companyId,
    applicationQuizId: props.applicationQuizId,
  });

  if (quizIsLoading) {
    return <DimensionsBentoSkeleton />;
  }

  if (!quiz) {
    return null;
  }

  const dimensions = quiz?.dimensionsSummary.map(mergeWithConfig) || [];

  return (
    <div
      className={cn(
        "grid gap-4",
        gridStyle === "grid" && "lg:grid-cols-2",
        gridStyle === "compact" && "auto-cols-fr grid-flow-col",
        props.className,
      )}
    >
      {dimensions.map((dimension) => (
        <DimensionSummaryCard
          key={dimension.dimension}
          className={cn(
            dimension.group === "GENERAL_INFORMATION" &&
              gridStyle === "grid" &&
              "lg:col-span-2",
          )}
          dimensionId={dimension.dimension}
          editionId={quiz.edition.id}
          showExtraInfo={props.showExtraInfo}
          title={dimension.name}
          description={dimension.description}
          color={dimension.color}
          icon={dimension.icon}
          completedTopics={dimension.completedTopicsCount}
          totalTopics={dimension.topicsCount}
          completedPercentage={dimension.completedPercentage}
          scoreProportion={dimension.scoreProportion}
          sbowScoreProportionInHeader={
            dimension.group !== "GENERAL_INFORMATION" &&
            props.showScoreProportionInHeader
          }
          buttonText={
            gridStyle === "grid"
              ? dimension.group === "GENERAL_INFORMATION"
                ? "Ver formulario"
                : undefined
              : "Ver"
          }
          useCompactStyle={gridStyle === "compact"}
        />
      ))}
    </div>
  );
};

export default DimensionsBentoGrid;
